const KEY = "brioni-recent-slabs";
const MAX = 8;

export const getRecent = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(raw) ? raw.slice(0, MAX) : [];
  } catch {
    return [];
  }
};

export const pushRecent = (key) => {
  if (!key) return;
  const next = [key, ...getRecent().filter((k) => k !== key)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
};

export const clearRecent = () => localStorage.removeItem(KEY);
